import ConsultantAssign from './ConsultantAssign';

export default ConsultantAssign;
